import { render, staticRenderFns } from "./Row.vue?vue&type=template&id=10a5a3a6&scoped=true&"
import script from "./Row.vue?vue&type=script&lang=ts&"
export * from "./Row.vue?vue&type=script&lang=ts&"
import style0 from "./Row.vue?vue&type=style&index=0&id=10a5a3a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a5a3a6",
  null
  
)

export default component.exports